import React, { useEffect, useRef } from 'react';
import LineSVG from './Line';
import PolylineSVG from './Polyline';

const AnimatedLine = ({w}) => {
    const line1 = useRef(null);
    const line2 = useRef(null);
    const line3 = useRef(null);
    const line4 = useRef(null);
    const line5 = useRef(null);

    useEffect(() => {
        const setOpacity = (lines, opacity) => {
            lines.forEach(line => { if (line.current) line.current.style.opacity = opacity; });
        };
        const getLenght = (line) => line.current.getTotalLength();
        const drawLine = (line, currentLength, totalLength) => {
            line.current.style.strokeDasharray = `${currentLength} ${totalLength}`;
        };

        // CSS heights of each AnimatedLine segment (must match h-[Xpx] in JSX below)
        const h1 = 1000, h2 = 1300, h3 = 1300, h5 = 800, h4 = 1300;

        // Measure once where the AnimatedLine starts in the document
        const header = document.getElementById('main_opener_content');
        let animLineStart = header ? header.offsetHeight : window.innerHeight;
        const updateStart = () => {
            animLineStart = header ? header.offsetHeight : window.innerHeight;
        };
        window.addEventListener('resize', updateStart);

        const handleScroll = () => {
            if (!line1.current) return;

            // Anchor at viewport center: the line tip tracks the center of the screen
            const scrollIntoLine = Math.max(0, window.scrollY + window.innerHeight * 0.5 - animLineStart);

            const tl1 = getLenght(line1);
            const tl2 = getLenght(line2);
            const tl3 = getLenght(line3);
            const tl5 = getLenght(line5);
            const tl4 = getLenght(line4);

            setOpacity([line2, line3, line5, line4], 0);

            const p1 = Math.min(1, scrollIntoLine / h1);
            drawLine(line1, p1 * tl1, tl1);

            if (p1 >= 1) {
                setOpacity([line2], 1);
                const p2 = Math.min(1, (scrollIntoLine - h1) / h2);
                drawLine(line2, p2 * tl2, tl2);

                if (p2 >= 1) {
                    setOpacity([line3], 1);
                    const p3 = Math.min(1, (scrollIntoLine - h1 - h2) / h3);
                    drawLine(line3, p3 * tl3, tl3);

                    if (p3 >= 1) {
                        setOpacity([line5], 1);
                        const p5 = Math.min(1, (scrollIntoLine - h1 - h2 - h3) / h5);
                        drawLine(line5, p5 * tl5, tl5);

                        if (p5 >= 1) {
                            setOpacity([line4], 1);
                            const p4 = Math.min(1, (scrollIntoLine - h1 - h2 - h3 - h5) / h4);
                            drawLine(line4, p4 * tl4, tl4);
                        }
                    }
                }
            }
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
            window.removeEventListener('resize', updateStart);
        };
    }, []);

    return (
        <section className='grid grid-cols-1 lg:grid-cols-6 w-full overflow-hidden'>
            <div></div>
            <div className='lg:col-span-4'>
                <div className={`h-[1000px] 3xl:w-[1600px] 2xl:w-[1300px] xl:w-[1000px]`}>
                    <LineSVG w={w} h={1000} stroke='#212121' strokeWidth='0.2rem' referring={line1} />
                </div>
                <div className={`h-[1300px] 3xl:w-[1600px] 2xl:w-[1300px] xl:w-[1000px]`}>
                    <PolylineSVG w={w} h={1300} points={`${w} 1 ${w} 1150 1 1150 1 1300`} stroke='#f6f6f6' strokeWidth='0.2rem' referring={line2} />
                </div>
                <div className={`h-[1300px] 3xl:w-[1600px] 2xl:w-[1300px] xl:w-[1300px]`}>
                    <LineSVG w={w} h={1300} x1={0} x2={0} stroke='#212121' strokeWidth='0.2rem' referring={line3} />
                </div>
                <div className={`h-[800px] 3xl:w-[1600px] 2xl:w-[1300px] xl:w-[1300px]`}>
                    <LineSVG w={w} h={800} x1={0} x2={0} stroke='#212121' strokeWidth='0.2rem' referring={line5} />
                </div>
                <div className={`h-[1300px] 3xl:w-[1600px] 2xl:w-[1300px] xl:w-[1000px]`}>
                    <PolylineSVG w={w} h={1300} points='1 0 1 1100 6400 1100' stroke='#f6f6f6' strokeWidth='0.2rem' referring={line4} />
                </div>
            </div>
            <div></div>
        </section>
    );
};

export default AnimatedLine;
